import styled from 'styled-components';
import NewPasswordChangedIcon from '@/images/NewPasswordChangedIcon.svg?react';
import { COLORS } from '@/styles/colors';
import { headline4 } from '@/styles/typography';

export const CreatePasswordMessage = styled.div`
  margin-bottom: 32px;
  text-align: center;
  color: ${COLORS.grey[900]};
  ${headline4};
  font-weight: 600;
`;

export const ChangedPasswordIcon = styled(NewPasswordChangedIcon)`
  margin: 0 auto;
`;
